<template>
  <div>
    <vs-popup :title="data.title" :active.sync="detailsPopupActive">
      <div>
        <div class="flex items-start">
          <span
            class="
              template-options-btn-icon
              p-4
              inline-flex
              feather-icon
              text-primary
              mr-3
            "
            :style="{ background: data.color, 'border-radius': '10px' }"
          >
            <img :src="data.icon" width="28px" height="28px" />
          </span>
          <div class="relative m-1">
            <h4 class="mb-1">{{ data.title }}</h4>
            <p>{{ data.shortDescription }}</p>
          </div>
        </div>
        <vs-divider />
        <div>
          <p v-html="data.description"></p>
        </div>
        <vs-divider />
        <div v-if="data.ss1">
          <img :src="data.ss1" width="50%" />
        </div>
      </div>
    </vs-popup>
    <vx-card class="marketplace--item">
      <div class="vx-row flex justify-between flex-wrap mb-5">
        <div class="vx-col">
          <span
            class="
              template-options-btn-icon
              p-2
              inline-flex
              feather-icon
              text-primary
              mr-3
            "
            :style="{ background: color, 'border-radius': '10px' }"
          >
            <img :src="icon" width="28px" height="28px" />
          </span>
        </div>
        <div class="vx-col">
          <!-- <vs-button @click.stop="detailsPopupActive=true" color="#44CC88" type="filled">Get</vs-button> -->
        </div>
      </div>
      <div class="mb-base">
        <h4 class="mb-1">{{ title }}</h4>
        <p v-if="data.shortDescription" class="wrap-text">
          <span v-if="data.shortDescription.length <= 74">{{
            data.shortDescription.substring(0, 75)
          }}</span>
          <span v-else>{{ data.shortDescription.substring(0, 74) }}...</span>
        </p>
        <p v-else class="wrap-text">Lorem ipsum dolor sit amet consetetur...</p>
      </div>
      <div class="flex justify-between flex-wrap" style="align-items: center">
        <vs-button type="border" @click="detailsPopupActive = true"
          >App Info</vs-button
        >
        <vs-button v-if="baseURL" type="filled" :href="launchUrl"
          >Launch</vs-button
        >
      </div>
    </vx-card>
  </div>
</template>

<script>
import Details from "../Details.vue";
import constants from "@/constants.js";
export default {
  components: { Details },
  props: [
    "title",
    "description",
    "icon",
    "color",
    "baseURL",
    "boardUserId",
    "boardSlug",
    "data",
    "currentUserLevelBoard",
  ],
  data() {
    return {
      detailsPopupActive: false,
      constants,
    };
  },
  computed: {
    accessToken() {
      return this.$store.state.auth.accessToken;
    },
    launchUrl() {
      if (this.data.id === "comm-server") {
        return `${constants.commServiceUrl}/rkt/${this.currentUserLevelBoard.orgData.slug}/login/${this.accessToken}`;
      }
      return `/${this.boardSlug}/${this.boardUserId}/${this.baseURL}`;
    },
  },
};
</script>

<style scoped>
.marketplace--item {
  box-sizing: border-box;
  border-radius: 6px;
}
</style>